export const zIndexMap = {
  contextMenu: 110,
  styleAnalysis: 120,
  viewMenu: 55,
  viewMenuIcon: 48,
  clickToInteractOverlay: 100,
  schematicComponentDetailsTooltip: 105,
  schematicComponentHoverOutline: 47,
  schematicPortHoverOutline: 48,
  schematicSearch: 101,
}
